const Flickity = require('flickity');
require('flickity-fade');

let heroSlider = document.querySelectorAll('.hero-slider');
if( typeof(heroSlider) != 'undefined' && heroSlider != null ) {
  heroSlider.forEach( (element) => {
		const heroCells = element.querySelectorAll('.hero-cell');
    window.HeroCarousel = new Flickity(element, {
			// options
			cellAlign: 'left',
			freeScroll: true,
			contain: true,
			pageDots: heroCells.length > 1,
			prevNextButtons: false,
			imagesLoaded: true,
			fade: true,
			autoPlay: 3500,
			wrapAround: true,
			pauseAutoPlayOnHover: false,
			draggable: false,
			on: {
			ready: function( index ) {
		//		if(index > 0) {

					element.classList.add('enable-transition');
			//	}
			}
		}
		});
  });
}

// HeroCarousel.options.autoPla